import { DeleteOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row, Select } from "antd";
import React from "react";
import { opcionesDesgloseCarretero } from "../../../../constants/cons";
import { formatCurrency } from "../../../../utils/formatCurrency";

export const ListaItems = ({ filas, actualizarFila, eliminarFila }) =>
  filas.map((fila, index) => {
    const subtotal = Number(fila.cantidad) * Number(fila.costo);

    return (
      <Row key={index} gutter={[8, 8]} align="bottom" style={{ marginBottom: 8 }}>
        <Col xs={24} md={4}>
          <div className="labelImput">Cantidad</div>
          <Input
            type="number"
            value={fila.cantidad}
            onChange={({ target }) =>
              actualizarFila(index, "cantidad", target.value)
            }
          />
        </Col>
        <Col xs={24} md={9}>
          <div className="labelImput">Concepto</div>
          <Select
            style={{ width: "100%" }}
            onChange={(valor) => actualizarFila(index, "tipoCosto", valor)}
            options={opcionesDesgloseCarretero}
            placeholder="Seleccione una opción"
            value={fila.tipoCosto}
          />
        </Col>
        <Col xs={12} md={5}>
          <div className="labelImput">Precio unitario</div>
          <Input
            type="number"
            value={fila.costo}
            onChange={({ target }) =>
              actualizarFila(index, "costo", target.value)
            }
          />
        </Col>
        <Col xs={20} md={5}>
          <div className="labelImput">Subtotal</div>
          <Input value={formatCurrency(subtotal)} disabled />
        </Col>
        <Col xs={4} md={1}>
          <Button
            danger
            type="text"
            aria-label="Eliminar concepto"
            icon={<DeleteOutlined />}
            onClick={() => eliminarFila(index)}
          />
        </Col>
      </Row>
    );
  });
